import {
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
} from "@ui/components/ui/card";
import { useToast } from "@ui/hooks/use-toast";
import { Mail } from "lucide-react";
import { LoginForm, TLoginFormData } from "../components/LoginForm";
import { useAuth, useLogin } from "../hooks";

export function LoginPage() {
    const { login } = useAuth();
    const loginMutation = useLogin();
    const { toast } = useToast();

    const handleSubmit = async (formData: TLoginFormData) => {
        try {
            await login({ email: formData.email, password: formData.password });
        } catch {
            toast({
                variant: "destructive",
                title: "Sign in failed",
                description: "The email or password you entered is incorrect.",
            });
        }
    };

    return (
        <div className="flex min-h-screen items-center justify-center bg-background px-4">
            <div className="w-full max-w-sm">
                <div className="mb-8 flex flex-col items-center gap-2">
                    <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10">
                        <Mail className="h-6 w-6 text-primary" />
                    </div>
                    <h1 className="text-2xl font-bold tracking-tight">AVA Smart Mail</h1>
                    <p className="text-sm text-muted-foreground">AI-powered email drafting</p>
                </div>

                <Card>
                    <CardHeader className="space-y-1">
                        <CardTitle className="text-xl">Welcome back</CardTitle>
                        <CardDescription>Sign in to your account to continue</CardDescription>
                    </CardHeader>
                    <CardContent>
                        <LoginForm
                            onSubmit={handleSubmit}
                            isLoading={loginMutation.isPending}
                        />
                    </CardContent>
                </Card>
            </div>
        </div>
    );
}
